import _isNumber from 'lodash/isNumber';

export default function getPaymentType(amount = 0) {
  if (!_isNumber(amount)) return '';

  return amount < 0 ? 'Upsell' : amount > 0 ? 'Refund' : 'N/A';
}
